
export default function CampsSection() {
  const summerCamps = [
    {
      title: '美語探險營',
      age: '6-9歲',
      duration: '2週',
      image: 'https://public.readdy.ai/ai/img_res/3592cb9820079231dcd172028ba1e3c1.jpg',
      features: ['戶外探險', '美語遊戲', '自然觀察', '團隊合作'],
      description: '結合戶外探險與美語學習，讓孩子在大自然中快樂學習英文。'
    },
    {
      title: '科學實驗營',
      age: '8-12歲',
      duration: '3週',
      image: 'https://readdy.ai/api/search-image?query=English%20science%20experiment%20camp%20for%20children%20aged%208-12%2C%20kids%20doing%20science%20experiments%20in%20laboratory%2C%20teacher%20explaining%20in%20English%2C%20colorful%20chemicals%20and%20equipment%2C%20educational%20STEM%20environment&width=400&height=300&seq=summer2&orientation=landscape',
      features: ['科學實驗', '英文指令', 'STEM教育', '創意思考'],
      description: '透過有趣的科學實驗，用英文學習科學知識，培養邏輯思維能力。'
    },
    {
      title: '戲劇表演營',
      age: '10-14歲',
      duration: '3週',
      image: 'https://readdy.ai/api/search-image?query=English%20drama%20and%20theater%20camp%20for%20children%20aged%2010-14%2C%20kids%20rehearsing%20plays%20and%20performances%2C%20stage%20with%20costumes%20and%20props%2C%20creative%20artistic%20atmosphere%2C%20theater%20workshop%20setting&width=400&height=300&seq=summer3&orientation=landscape',
      features: ['戲劇表演', '口語表達', '創意發想', '自信建立'],
      description: '通過戲劇表演訓練口語表達，提升英語會話能力與舞台表現力。'
    }
  ];

  const winterCamps = [
    {
      title: '節慶文化營',
      age: '5-10歲',
      duration: '1週',
      image: 'https://readdy.ai/api/search-image?query=Winter%20English%20cultural%20festival%20camp%20for%20children%20aged%205-10%2C%20kids%20learning%20about%20Christmas%20and%20winter%20traditions%2C%20classroom%20decorated%20with%20festive%20items%2C%20cultural%20learning%20activities&width=400&height=300&seq=winter1&orientation=landscape',
      features: ['節慶文化', '手作活動', '歌曲學習', '文化體驗'],
      description: '認識西方節慶文化，透過手作與歌曲學習相關的英文詞彙。'
    },
    {
      title: '烘焙料理營',
      age: '7-12歲',
      duration: '2週',
      image: 'https://readdy.ai/api/search-image?query=Winter%20English%20cooking%20and%20baking%20camp%20for%20children%20aged%207-12%2C%20kids%20learning%20to%20bake%20and%20cook%20with%20English%20instructions%2C%20kitchen%20classroom%20with%20ovens%20and%20ingredients%2C%20culinary%20education%20setting&width=400&height=300&seq=winter2&orientation=landscape',
      features: ['烘焙技巧', '英文食譜', '數學應用', '生活技能'],
      description: '學習簡單烘焙技巧，用英文理解食譜，培養生活實用技能。'
    },
    {
      title: '冬令閱讀營',
      age: '8-14歲',
      duration: '2週',
      image: 'https://readdy.ai/api/search-image?query=Winter%20English%20reading%20camp%20for%20children%20aged%208-14%2C%20kids%20reading%20books%20in%20cozy%20library%20setting%2C%20winter%20atmosphere%20with%20warm%20lighting%2C%20students%20discussing%20books%20together%2C%20literary%20education%20environment&width=400&height=300&seq=winter3&orientation=landscape',
      features: ['英文閱讀', '故事分享', '讀書報告', '思辨能力'],
      description: '深度閱讀英文書籍，培養閱讀理解能力與批判思考技巧。'
    }
  ];

  const campFeatures = [
    {
      icon: 'ri-shield-check-line',
      title: '安全保障',
      description: '全程專業教師陪同，完善的安全防護措施'
    },
    {
      icon: 'ri-restaurant-line',
      title: '營養餐點',
      description: '專業營養師規劃，健康美味的三餐與點心'
    },
    {
      icon: 'ri-camera-line',
      title: '活動紀錄',
      description: '專業攝影記錄營隊生活，與家長分享精彩時刻'
    },
    {
      icon: 'ri-medal-line',
      title: '結業證書',
      description: '營隊結束頒發結業證書，肯定孩子的學習成果'
    }
  ];

  return (
    <section id="camps" className="py-20 bg-gradient-to-br from-orange-50 to-pink-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">
            CMAP運動健康品格寒/暑假營隊
            <a 
              href="https://www.cmapedu.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="ml-3 text-lg text-blue-600 hover:text-blue-800 transition-colors cursor-pointer"
            >
              <i className="ri-external-link-line mr-1"></i>
              詳細內容
            </a>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            寒暑假期間舉辦精彩的主題營隊活動，讓孩子在假期中也能持續學習，
            透過多元化的活動體驗，拓展視野並提升英語能力。
          </p>
        </div>

        {/* 夏令營 */}
        <div className="mb-20">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-orange-600 mb-4">
              <i className="ri-sun-line mr-2"></i>
              夏令營活動
            </h3>
            <p className="text-gray-600">充滿活力的夏日學習體驗</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            {summerCamps.map((camp, index) => (
              <div key={index} className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
                <img 
                  src={camp.image}
                  alt={camp.title}
                  className="w-full h-48 object-cover object-top"
                />
                <div className="p-6">
                  <div className="flex items-center justify-between mb-4">
                    <h4 className="text-xl font-bold text-gray-800">{camp.title}</h4>
                    <div className="text-right">
                      <span className="bg-orange-100 text-orange-800 px-2 py-1 rounded-full text-xs font-medium block mb-1">
                        {camp.age}
                      </span>
                      <span className="bg-gray-200 text-gray-700 px-2 py-1 rounded text-xs">
                        {camp.duration}
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-600 mb-4 text-sm leading-relaxed">{camp.description}</p>
                  <div className="grid grid-cols-2 gap-2">
                    {camp.features.map((feature, featureIndex) => (
                      <div key={featureIndex} className="flex items-center">
                        <i className="ri-check-line text-orange-500 mr-2"></i>
                        <span className="text-xs text-gray-700">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 冬令營 */}
        <div className="mb-16">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-blue-600 mb-4">
              <i className="ri-snowy-line mr-2"></i>
              冬令營活動
            </h3>
            <p className="text-gray-600">溫馨充實的冬日學習時光</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {winterCamps.map((camp, index) => (
              <div key={index} className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
                <img 
                  src={camp.image}
                  alt={camp.title}
                  className="w-full h-48 object-cover object-top"
                />
                <div className="p-6">
                  <div className="flex items-center justify-between mb-4">
                    <h4 className="text-xl font-bold text-gray-800">{camp.title}</h4>
                    <div className="text-right">
                      <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-xs font-medium block mb-1">
                        {camp.age}
                      </span>
                      <span className="bg-gray-200 text-gray-700 px-2 py-1 rounded text-xs">
                        {camp.duration}
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-600 mb-4 text-sm leading-relaxed">{camp.description}</p>
                  <div className="grid grid-cols-2 gap-2">
                    {camp.features.map((feature, featureIndex) => (
                      <div key={featureIndex} className="flex items-center">
                        <i className="ri-check-line text-blue-500 mr-2"></i>
                        <span className="text-xs text-gray-700">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 營隊特色 */}
        <div className="bg-white rounded-lg p-8 shadow-lg">
          <h3 className="text-2xl font-bold text-gray-800 text-center mb-8">營隊服務特色</h3>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            {campFeatures.map((feature, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-orange-100 to-pink-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className={`${feature.icon} text-orange-600 text-2xl`}></i>
                </div>
                <h4 className="font-semibold mb-2 text-gray-800">{feature.title}</h4>
                <p className="text-sm text-gray-600">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
